import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const TOUR_STEPS = [
  { title: 'Benvenuto nella Dashboard!', desc: 'Questo tour ti guida nelle sezioni principali. Dura 30 secondi.', icon: '👋', highlight: null },
  { title: 'Inventario', desc: 'Qui aggiungi e gestisci i tuoi prodotti. Carica foto, imposta prezzi e tieni tutto organizzato.', icon: '📦', highlight: '/products', btn: 'Vai all\'Inventario' },
  { title: 'Vendite', desc: 'Registra ogni vendita per tracciare profitti, margini e statistiche del tuo business.', icon: '💰', highlight: '/vendite', btn: 'Vai alle Vendite' },
  { title: 'Corso Reselling', desc: '4 moduli progressivi per imparare a vendere come un professionista. Inizia dal Modulo 1.', icon: '🎓', highlight: '/corso', btn: 'Vai al Corso' },
  { title: 'Fornitori', desc: 'Contatti esclusivi selezionati da Willy per comprare all\'ingrosso e rivendere con margine.', icon: '🤝', highlight: '/fornitori', btn: 'Vai ai Fornitori' },
  { title: 'Guida Completa', desc: 'Hai dubbi? Nella Guida trovi tutorial dettagliati per ogni funzione della Dashboard.', icon: '📖', highlight: '/guida', btn: 'Leggi la Guida' },
  { title: 'Tutto pronto!', desc: 'Hai visto le basi. Inizia aggiungendo il tuo primo prodotto e segui il corso per scalare.', icon: '🚀', highlight: null },
];

export default function TourGuide({ onComplete }) {
  const [step, setStep] = useState(0);
  const [visible, setVisible] = useState(true);
  const navigate = useNavigate();
  const current = TOUR_STEPS[step];
  const isLast = step === TOUR_STEPS.length - 1;

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  const finish = () => {
    localStorage.setItem('tour_completed', 'true');
    setVisible(false);
    onComplete();
  };

  const next = () => {
    if (isLast) { finish(); return; }
    setStep(s => s + 1);
  };

  const goTo = (path) => {
    finish();
    navigate(path);
  };

  if (!visible) return null;

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(13,11,30,0.92)', backdropFilter: 'blur(6px)' }}>
      <div style={{ maxWidth: 420, width: '100%', padding: 16, animation: 'countUp 0.4s ease-out' }}>
        <div style={{ background: '#151230', border: '1px solid #2d1b69', borderRadius: 20, padding: 32, textAlign: 'center', position: 'relative', boxShadow: '0 0 60px rgba(124,58,237,0.2)' }}>
          {/* Progress dots */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: 6, marginBottom: 20 }}>
            {TOUR_STEPS.map((_, i) => (
              <div key={i} style={{ width: i === step ? 20 : 6, height: 6, borderRadius: 9999, background: i === step ? '#7c3aed' : i < step ? '#a78bfa' : '#2d1b69', transition: 'all 0.3s' }} />
            ))}
          </div>

          {/* Icon */}
          <div style={{ width: 64, height: 64, borderRadius: 16, background: 'linear-gradient(135deg,rgba(124,58,237,0.2),rgba(79,70,229,0.1))', border: '1px solid rgba(124,58,237,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', fontSize: '1.8rem' }}>
            {current.icon}
          </div>

          {/* Content */}
          <h2 style={{ fontFamily: 'Syne,sans-serif', fontSize: '1.3rem', fontWeight: 800, color: '#e2e8f0', marginBottom: 8 }}>{current.title}</h2>
          <p style={{ color: '#9ca3af', fontSize: '0.88rem', lineHeight: 1.6, marginBottom: 24, minHeight: 44 }}>{current.desc}</p>

          {/* Action buttons */}
          <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
            {current.btn && current.highlight && (
              <button onClick={() => goTo(current.highlight)} style={{
                padding: '10px 20px', background: 'transparent', border: '1px solid #a78bfa', borderRadius: 9999,
                color: '#a78bfa', fontWeight: 700, fontSize: '0.85rem', cursor: 'pointer', fontFamily: 'DM Sans,sans-serif',
              }}>
                {current.btn}
              </button>
            )}
            <button onClick={next} style={{
              padding: '10px 24px', background: 'linear-gradient(135deg,#7c3aed,#4f46e5)', border: 'none', borderRadius: 9999,
              color: 'white', fontWeight: 700, fontSize: '0.85rem', cursor: 'pointer', fontFamily: 'DM Sans,sans-serif',
              boxShadow: '0 4px 16px rgba(124,58,237,0.4)',
            }}>
              {isLast ? 'Inizia!' : 'Avanti →'}
            </button>
          </div>

          {/* Skip */}
          {!isLast && (
            <button onClick={finish} style={{ marginTop: 12, background: 'none', border: 'none', color: '#6b7280', fontSize: '0.78rem', cursor: 'pointer' }}>
              Salta il tour
            </button>
          )}

          {/* Step counter */}
          <p style={{ color: '#4b5563', fontSize: '0.7rem', marginTop: 12 }}>{step + 1} / {TOUR_STEPS.length}</p>
        </div>
      </div>
    </div>
  );
}
